var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen"},[_c('h2',[_vm._v("It takes 2 to 4 minutes to convert the file. Thank you for your patience. However, once converted, the file will be available immediately.")]),_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"lds-roller"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])])])
}]

export { render, staticRenderFns }